export default {
  Latitude: '',
  Longitude: '',

};
